import React, { forwardRef, useEffect, useState } from "react";
import Repo from "../../../Repository/Repo";
import moment from "moment";
import { Box, Divider, Stack, Typography, styled } from "@mui/material";
import Loader from "../../components/Loader";

const Title = styled(Typography)({
  margin: "10px 0px",
  fontWeight: 700,
  fontSize: "20px",
  textAlign: "center",
});
const SubTitle = styled(Typography)({
  fontSize: "17px",
});
const TotalBox = styled(Box)({
  width: "fit-content",
  borderTop: "1px solid grey",
});

const ProfitLoss = forwardRef((props, ref) => {
  const { start, end } = props;
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    salesTotal: 0,
    expenses: [],
    purchaseTotal: 0,
    discount: 0,
    totalExpense: 0,
  });

  useEffect(() => {
    if (start && end) {
      getProfitLoss();
    }
  }, [start, end]);

  const getProfitLoss = async () => {
    setLoading(true);
    let { data } = await Repo.bills({
      request: {
        method: "getProfitLossStatement",
        data: {
          company_code: localStorage.getItem("companyCode"),
          startDate: start ? moment(start).format("DD-MM-YYYY") : "",
          endDate: end ? moment(end).format("DD-MM-YYYY") : "",
        },
      },
    });
    setLoading(false);
    const { salesTotal, discount, totalExpense, expenses, purchaseTotal } =
      data.response.data;
    setState({ discount, salesTotal, totalExpense, expenses, purchaseTotal });
  };
  return (
    <Box>
      {!loading && (
        <Box ref={ref} sx={{ m: 5 }}>
          <Title className="f-16">Ordinary Income/Expense</Title>
          <SubTitle sx={{ fontWeight: 700 }} className="f-16">
            Income
          </SubTitle>
          <Divider />
          <Stack direction="row" width="100%" justifyContent="space-between">
            <SubTitle>Sales</SubTitle>
            <SubTitle>{state?.salesTotal}</SubTitle>
          </Stack>
          <Stack direction="row" width="100%" justifyContent="space-between">
            <SubTitle>Sales Discount</SubTitle>
            <SubTitle>{state?.discount}</SubTitle>
          </Stack>
          <Stack direction="row" width="100%" justifyContent="space-between">
            <SubTitle>Total Income</SubTitle>
            <TotalBox>
              <SubTitle>{state?.salesTotal + state?.discount}</SubTitle>
            </TotalBox>
          </Stack>
          <Title className="f-16">Total Income</Title>
          <SubTitle sx={{ fontWeight: 700, mt: 2 }} className="f-16">
            Cost of Goods Sold
          </SubTitle>
          <Divider />

          <Stack direction="row" width="100%" justifyContent="space-between">
            <SubTitle>Cost of Goods Sold</SubTitle>
            <SubTitle>{state?.purchaseTotal}</SubTitle>
          </Stack>

          <Stack direction="row" width="100%" justifyContent="space-between">
            <SubTitle>Total COGS</SubTitle>
            <TotalBox>
              <SubTitle>{state?.purchaseTotal}</SubTitle>
            </TotalBox>
          </Stack>
          <Stack direction="row" width="100%" justifyContent="space-between">
            <SubTitle>Gross Profit</SubTitle>
            <TotalBox>
              <SubTitle>
                {state?.salesTotal + state?.discount - state?.purchaseTotal}
              </SubTitle>
            </TotalBox>
          </Stack>
          <Title className="f-16">Expense</Title>
          <SubTitle sx={{ fontWeight: 700, mt: 2 }} className="f-16">
            Admin Expenses
          </SubTitle>
          <Divider />
          {state?.expenses?.map((item, i) => {
            return (
              <Stack
                key={i}
                direction="row"
                width="100%"
                justifyContent="space-between"
              >
                <SubTitle>{item.name}</SubTitle>
                <SubTitle>{item.debit}</SubTitle>
              </Stack>
            );
          })}
          <Stack direction="row" width="100%" justifyContent="space-between">
            <SubTitle>Total Admin Expenses</SubTitle>
            <TotalBox>
              <SubTitle>{state?.totalExpense}</SubTitle>
            </TotalBox>
          </Stack>

          <Title className="f-16">Final Results</Title>
          <Stack direction="row" width="100%" justifyContent="space-between">
            <SubTitle>Net income net profit</SubTitle>
            <SubTitle>
              {state?.salesTotal +
                state?.discount -
                state?.purchaseTotal -
                state?.totalExpense}
            </SubTitle>
          </Stack>
        </Box>
      )}
      {loading && <Loader loading={loading} />}
    </Box>
  );
});
export default ProfitLoss;
